import { render } from "./Dostave.vue?vue&type=template&id=4d3fa2c2&scoped=true"
import script from "./Dostave.vue?vue&type=script&lang=js"
export * from "./Dostave.vue?vue&type=script&lang=js"

import "./Dostave.vue?vue&type=style&index=0&id=4d3fa2c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3fa2c2"]])

export default __exports__